import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class InventoryItemAPI extends DIApi {
  controllerName = 'inventoryItems';

  /**
   * Lấy dữ liệu mặc định tài khoản chi phí
   * dqdat1 04.07.2022
   */
  async getDefaultCost(payload) {
    let request = {
      url: this.getAPIUrl() + '/defaultCost',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách tham số báo cáo tồn kho
   * @param {*} payload 
   * ntchuyen 14.12.2023
   */
  getListInventoryItem(payload) {
    let request = {
      url: this.getAPIUrl() + '/inventoryItems',
      data: payload,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu mặc định tài khoản bán hàng
   * dqdat1 04.07.2022
   */
  async getDefaultSale(payload) {
    let request = {
      url: this.getAPIUrl() + '/defaultSale',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu vật tư hàng hóa theo mã ID
   * @param {*} payload
   * @returns
   * NTLOC 23.08.2022
   */
  getInventoryItemList(payload) {
    let request = {
      url: this.getAPIUrl() + '/dataInventoryItem',
      data: payload,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu công cụ dụng cụ
   * @param {*} payload
   * @returns
   * PSHAI 04.01.2023
   */
  getToolItemList(payload) {
    let request = {
      url: this.getAPIUrl() + '/getAllToolItem',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu chứng từ liên quan
   * @param {*} payload
   * @returns
   * DMNgOC 16.01.2023
   */
  getAriseList(id) {
    let request = {
      url: this.getAPIUrl() + '/getAriseList/' + id,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy các chứng từ liên quan
   * @param {*} payload
   * @returns
   * NNKiem 10.08.2023
   * Modified by NVTUAN1 25.04.2024: Cải tiến load phân trang
   */
  async getVoucherReference(payload) {
    let request = {
      url: this.getAPIUrl() + '/VoucherReference',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Sửa hàng loạt vật tư hàng hóa
   * @param {*} payload
   * @returns
   * dqdat1 07.06.2023
   */
  updateBatch(payload) {
    let request = {
      url: this.getAPIUrl() + '/updateBatch',
      data: payload,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách cho tìm nhanh
   */
  getListQuickSearch(payload) {
    let request = {
      url: this.getAPIUrl() + '/listQuickSearch',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new InventoryItemAPI();
